import {
  FaCalendarCheck,
  FaGears,
  FaHouse,
  FaListCheck,
  FaLocationDot,
  FaOilWell,
  FaSquarePollVertical,
  FaTriangleExclamation,
  FaWrench,
} from "react-icons/fa6";

const MenuPnjTransport = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Operasional Mobil",
    type: "menu-title",
  },
  {
    label: "Jadwal Mobil",
    to: "transaksi/jadwal-mobil",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Mobil",
    to: "transaksi/cek-keluar-masuk",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Mobil",
    to: "problem/problem-kendaraan",
    icon: <FaGears />,
  },
  {
    label: "Warning Service",
    to: "service/warning-service",
    icon: <FaTriangleExclamation />,
  },
  {
    label: "Operasional Trado",
    type: "menu-title",
  },
  {
    label: "Jadwal Trado",
    to: "transaksi/jadwal-trado",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Trado",
    to: "transaksi/cek-keluar-masuk-trado",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Trado",
    to: "problem/problem-kendaraan-trado",
    icon: <FaGears />,
  },
  {
    label: "Operasional Transport",
    type: "menu-title",
  },
  {
    label: "Pengisian Minyak",
    to: "transaksi/kendaraan-pengisian-minyak",
    icon: <FaOilWell />,
  },
  {
    label: "Service Kendaraan",
    to: "transaksi/service-kendaraan",
    icon: <FaWrench />,
  },
  {
    label: "Kendaraan Retribusi",
    to: "transaksi/kendaraan-retribusi",
    icon: <FaListCheck />,
  },
  {
    label: "Laporan",
    type: "menu-title",
  },
  {
    label: "Laporan",
    to: "laporan",
    icon: <FaSquarePollVertical />,
  },
  {
    label: "Lain-Lain",
    type: "menu-title",
  },
];

export default MenuPnjTransport;
